import {
  sendGetHttpRequest,
  sendHttpRequest,
  sendPostHttpRequest,
} from "lib/fetcher";

export async function getDealerList(
  orgId: string,
  name: string,
  offset: number,
  limit: number,
) {
  return await sendGetHttpRequest(
    `/user/dealers?name=${name}&page.offset=${offset}&page.limit=${limit}`,
    orgId,
  );
}

export async function createDealer(
  orgId: string,
  email: string,
  dealerTimeZone: string,
  orgTimeZone: string,
  source: string,
) {
  return await sendPostHttpRequest(
    "/user/dealers",
    {
      email,
      dealerTimeZone,
      orgTimeZone,
      source,
    },
    orgId,
  );
}
export function editDealerEmail(id, email) {
  return sendHttpRequest({
    url: `/user/dealers/${id}`,
    method: "PUT",
    data: {
      email,
    },
  });
}
export function resendActivateEmail(id) {
  return sendHttpRequest({
    url: `/user/dealers/resend_activate_email`,
    method: "POST",
    data: {
      userId: id,
    },
  });
}
